import React from 'react';
import { getTitle } from './reducer';
import { mergeDeep } from '../../../../utils/Helper';
import { Mode } from '../../../../utils';
import { IOMode, IOType, IOTransferType } from '../../../IO/types';

export const Dispatch = React.createContext(null);

function addDays(date, days) {
	return new Date(date.setDate(date.getDate() + days));
}

export const initialize = ({ mode, io: originalIO, permissions, userType }) => initialState => {
	const state = mergeDeep(
		{ ...initialState },
		{
			ui: {
				mode,
				title: getTitle(originalIO, mode),
			},
			io: { ...originalIO },

		},
	);
	state.userType = userType;
	
	let { io, fields, ui, buttons } = state;

	// when create deposit and withdrawal simples require initialized item:0
	if (io.IOMode == IOMode.Simple && io.IOType != IOType.Transfer && io.items.length == 0) {
		io.items.push({Id: 1})
	}

	// store items commons properties in itemsHeader
	io.itemsHeader = { ...io.itemsHeader, ...io.items[0] };

	// delete redundant properties
	delete io.itemsHeader.Id;
	delete io.itemsHeader.Correlative;

	// backoffice roles can only add cash, value or both
	if (permissions) {
		const { allowCash, allowValues } = permissions;
		state.permissions = { ...permissions };

		// mode new
		if (!state.io.Id) {
			if (allowCash == false) {
				io.itemsHeader.IsCurrency = false;
			}

			if (allowValues == false) {
				io.itemsHeader.IsCurrency = true;
			}
		}
	}

	// Mode.READONLY
	if (ui.mode === Mode.READONLY || ui.mode === Mode.EXECUTE) {
		Object.keys(io).forEach(key => {
			fields.readonly[`${key}`] = true;
		});

		Object.keys(io.items[0]).forEach(key => {
			fields.readonly[`header_${key}`] = true;
		});

		if (io.IOMode == IOMode.Simple && io.IOType != IOType.Transfer) {
			Object.keys(io.items[0]).forEach(key => {
				fields.readonly[`simple_${key}`] = true;
			});
		}

		fields.readonly.SettlementDate = ui.mode !== Mode.EXECUTE;
		buttons.precheck.visible = false;
		buttons.confirm.visible = ui.mode === Mode.EXECUTE;
	}

	return {
		...state,
		ui,
		io,
		fields,
		buttons,
	};
};

export const defaultState = () => ({
	ui: {
		title: 'New deposit',
		mode: Mode.EDIT,
	},
	io: {
		Local: true,
		IOMode: IOMode.Simple,
		Date: new Date().toDateLocal(),
		SettlementDate: addDays(new Date(), 1).toDateLocal(),
		itemsHeader: {
			IsCurrency: true,
			TransferType: IOTransferType.Transfer,
		},
		items: [],
		files: [],
		ReasonId: "",
	},
	fields: {
		errors: {},
		readonly: {},
	},
	buttons: {
		confirm: { visible: false },
		precheck: { visible: true },
		modify: { visible: false },
	},
	entities: {
		accountBanks: [],
	},
	precheck: {
		authorizations: [],
	},
	permissions: {
		allowValues: true,
		allowCash: true,
	},
});
